/* GrubTerra homepage: food-waste counter. Counts up from 0 when scrolled into view. With a daily rate set it keeps climbing; with 0 it holds the number. */
(function () {
  var fmt = new Intl.NumberFormat('en-US');
  function current(el) {
    var base = Number(el.dataset.base) || 0;
    var baseTs = Number(el.dataset.baseTs) || 0;
    var perDay = Number(el.dataset.perDay) || 0;
    if (!baseTs || !perDay) return base;
    return base + Math.max(0, Math.floor(((Date.now() - baseTs) / 86400000) * perDay));
  }
  function start(el) {
    var out = el.querySelector('[data-gth-ticker-value]');
    if (!out) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var live = function () { out.textContent = fmt.format(current(el)); };
    if (reduce || !('IntersectionObserver' in window)) { live(); if (Number(el.dataset.perDay) > 0) setInterval(live, 1000); return; }
    var from = 0;
    // Drop to 0 only as the counter approaches the screen, so crawlers and no-scroll views keep the real number.
    var pre = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      pre.disconnect();
      if (!el.dataset.gthRun) out.textContent = fmt.format(from);
    }, { rootMargin: '0px 0px 400px 0px' });
    pre.observe(el);
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      el.dataset.gthRun = '1';
      var t0 = performance.now(), dur = 2200;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - k, 3);
        var goal = current(el);
        out.textContent = fmt.format(Math.round(from + (goal - from) * eased));
        if (k < 1) requestAnimationFrame(step); else if (Number(el.dataset.perDay) > 0) setInterval(live, 1000);
      })(t0);
    }, { threshold: 0.4 });
    io.observe(el);
  }
  function init() { document.querySelectorAll('[data-gth-ticker]').forEach(function (el) { if (!el.dataset.gthOn) { el.dataset.gthOn = '1'; start(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
